/**
 * Bot/Crawler detection based on User-Agent string.
 * Runtime: Edge/Node — no browser or Node-specific APIs used.
 */

const BOT_UA_PATTERN =
  /googlebot|bingbot|baiduspider|yandexbot|duckduckbot|sogou|360spider|slurp|adsbot-google|facebookexternalhit|semrushbot|ahrefsbot|mj12bot|crawler|crawling|spider|bingpreview|lighthouse|pagespeed|headless|curl|wget|\bbot\b/i;

/**
 * Check if a User-Agent string belongs to a bot/crawler.
 */
export function isBotUA(ua: string): boolean {
  if (!ua) return false;
  return BOT_UA_PATTERN.test(ua);
}
